// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/stylus-loader/index.js!./styles.styl");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("c5e596d0", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/views/work/styles/styles.styl
// module id = cd44126772b1c4438e18
// module chunks = 27